export default __webpack_public_path__ + "static/media/shuffle.8433f0c8.webp";